export enum DisplayState {
  READY = "ready",
  LOADING = "loading",
  PROCESSING = "processing",
  ERROR = "error",
  COMPLETE = "complete",
  EDITING = "editing",
  IDLE = "idle",
}
